import React, { useCallback, useContext, useEffect, useRef, useState, Fragment } from "react";
import { Forms } from "../../components/backgrounds/Forms";
import { Steps } from "../../components/buttons/Steps";
import { CreditUserContext } from "../../context/CreditUser/CreditUserContext";
import Numeral from "../../components/numeral/Numeral";
import { useNavigate } from "react-router-dom";
import { HttpRequest } from "../../services/httpRequest";
import { validateSessionAndJwtToken } from "../../utils/validateTokenSession";
import moment from "moment/moment";
import { OfferDialog } from "../../components/dialogs/OfferDialog";
import { AuthService } from "../../services/auth/auth.service";
import { CreditsService } from "../../services/credits/credits.service";
import { ErrorAlert } from "../../components/alerts/errorAlert";
import { TooltipInfoV2 } from "../../components/tooltips/tooltipInfo";
// import TagManager from "../../components/googleTag/TagManager";
import { CheckIcon } from "@heroicons/react/20/solid";
import { ViewContract } from "../../components/navigation/disclosure/ViewAgreements/ViewContract";
import { ManualSign } from "../../components/navigation/disclosure/ViewAgreements/ManualSign";
import { ViewPromissory } from "../../components/navigation/disclosure/ViewAgreements/ViewPromissory";
import { handleValidateUserHasValidCredit } from "../../utils/creditUser/validateUserHasValidCredit";
import { loadInfoUser, loadInfoUserAuth } from "../../utils/creditUser/helpers";
import {
  getAndSetInterestTea,
  getInterest,
} from "../../utils/creditUser/getInterest";
import {
  calcInteresCorrienteV2,
  calcularInteresCorrienteTed,
  calcularInteresCorrienteTem,
} from "../../utils/creditUser/calcInteresCorriente";
import { environment, variablesGlobales } from "../../configs/variables";
import { calcDescuentoFirmaElectronicaV1 } from "../../utils/creditUser/calcDescuentoFirmaElectronica";
import { convertToNumber, isValidNumber } from "../../utils/isValidNumber";
import { PhysicalSignatureSuccessDialog } from "../../components/dialogs/PhysicalSignatureSuccess";
import { APIClient } from "../../helpers/api_helper";
import {
  GET_AVAILABLE_REWARD,
  REQUEST_PROCESS_PHYSICAL_SIGNATURE,
  UPDATE_BASIC_INFO,
} from "../../helpers/url_helper";
import { ViewBankAccount } from "../../components/navigation/disclosure/ConfirmBankAccount/ViewBankAccount";
import { OfertaViewContext } from "../../context/OfertaContext/OfertaViewContext";
import { bankAccountOptionsFiltered } from "../../utils/options_selects";
import { FloatFooter } from "../../components/navigation/FloatFooter";
import {
  handleAddTimeline,
  setDataToLocalStorage,
  updateCreditContextFromViewOffer,
  updateMyBanksContextFromViewOffer,
  validateCreditDatesFromViewOffer,
} from "./helpers/helper";
import ViewTimer from "../../components/timers/viewTimer";

const cupoAprobado = "200000";
const apiClient = new APIClient();

export function OfertaPage() {
  const navigate = useNavigate();
  const url_string = window.location.href;
  const url = new URL(url_string);
  const fromapi = url.searchParams.get("fromapi");
  const creditIdFromApi = url.searchParams.get("creditId");
  const idOperation = url.searchParams.get("idOperation");
  const { creditUser, updateCreditUser } = useContext(CreditUserContext);
  const { updateMyBanks, updateBasicInfo, myBanks } =
    useContext(OfertaViewContext);

  const [messsageAlert, setMessageAlert] = useState("");
  const [isOpenAlert, setIsOpenAlert] = useState(false);
  const [viewalert, setViewalert] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [tooltip] = useState(true);
  const [basicInfo, setBasicInfo] = useState({});
  const [userinfo, setUserinfo] = useState({});
  const [checkFirmaElectronica, setCheckFirmaElectronica] = useState(true);
  const [firmaElectronicaValue, setFirmaElectronicaValue] = useState(0);
  const [dctoFirmaElectronica, setDctoFirmaElectronica] = useState(0);
  const [total, setTotal] = useState(0);
  const [interest, setInterest] = useState(0);
  const [openModalFirmaFisica, setOpenModalFirmaFisica] = useState(false);
  const [disableButton, setDisableButton] = useState(false);
  const [checkAcceptContract, setCheckAcceptContract] = useState(false);
  const [checkAcceptPromissory, setCheckAcceptPromissory] = useState(false);
  const [creditData, setCreditData] = useState({});
  const [openDialog, setOpenDialog] = useState(false);
  const [openLoader, setOpenLoader] = useState(false);
  const [successRequestPhysicalSignature, setSuccessRequestPhysicalSignature] =
    useState(false);
  const [checkValidateAccount, setCheckValidateAccount] = useState(false);
  const [discountForReward, setDiscountForReward] = useState(null);
  const [rewardHistoryAvailable, setRewardHistoryAvailable] = useState();
  const [tasaUsuraTmlvRate, setTasaUsuraTmlvRate] = useState("");

  // Snapshots sin volverlos dependencia reactiva de los efectos de cálculo financiero
  // de más abajo: esos mismos efectos escriben estos valores (directamente o vía
  // updateCreditUser), así que depender de ellos reactivamente reintroduciría el
  // ciclo documentado en cada efecto.
  const creditUserRef = useRef(creditUser);
  useEffect(() => {
    creditUserRef.current = creditUser;
  });
  const firmaElectronicaValueRef = useRef(firmaElectronicaValue);
  useEffect(() => {
    firmaElectronicaValueRef.current = firmaElectronicaValue;
  });
  const dctoFirmaElectronicaRef = useRef(dctoFirmaElectronica);
  useEffect(() => {
    dctoFirmaElectronicaRef.current = dctoFirmaElectronica;
  });
  const tasaUsuraTmlvRateRef = useRef(tasaUsuraTmlvRate);
  useEffect(() => {
    tasaUsuraTmlvRateRef.current = tasaUsuraTmlvRate;
  });

  const calcFirmaElectronica = useCallback((amount, vencimientoEnDias) => {
    let _firmaElectronica = firmaElectronicaValueRef.current;
    let dctoFirmaElectronica = calcDescuentoFirmaElectronicaV1(
      amount,
      vencimientoEnDias
    );
    let _firmaElectronicaTotal;
    if (dctoFirmaElectronica === _firmaElectronica) {
      setDctoFirmaElectronica(0);
      _firmaElectronicaTotal = _firmaElectronica;
    } else {
      setDctoFirmaElectronica(dctoFirmaElectronica);
      _firmaElectronicaTotal = _firmaElectronica - dctoFirmaElectronica;
    }
    return _firmaElectronicaTotal;
  }, []);

  const calculateInterest = useCallback((amount, vencimientoEnDias, rate) => {
    let tasa = localStorage.getItem("currentInterestRate");
    let tea = localStorage.getItem("currentInterestTea");
    tea = convertToNumber(tea);
    let tasaUsuraTmlv = tasaUsuraTmlvRateRef.current;
    if (tasaUsuraTmlv === undefined && rate !== undefined) {
      tasaUsuraTmlv = rate;
    }
    tasaUsuraTmlv = parseFloat(tasaUsuraTmlv.replace(",", "."));
    if (!isValidNumber(tea)) tea = 0;

    //si la tasa efectiva anual de interes corriente es mayor a la tasa de usura de la tasa máxima legal permitida se aplica la tasa de usura de la tasa máxima legal permitida
    if (tea > tasaUsuraTmlv) {
      console.log("Interes corriente tea > tasaUsuraTmlv");
      tea = tasaUsuraTmlv;
      localStorage.setItem("currentInterestTea", tea);
      let tasaNueva = calcCurrentInterestTed(tea);
      localStorage.setItem("currentInterestRate", tasaNueva);
      tasa = tasaNueva;
    }
    const interest2 = calcInteresCorrienteV2(amount, vencimientoEnDias, tasa);
    return interest2;
  }, []);

  const calcCurrentInterestTed = (tea) => {
    let interesCorrienteTea = parseFloat(tea);
    let interesCorrienteTem = calcularInteresCorrienteTem(interesCorrienteTea);
    let interesCorrienteTed = calcularInteresCorrienteTed(interesCorrienteTem);
    return interesCorrienteTed;
  };

  const calculateTotal = useCallback((amount, vencimientoEnDias) => {
    if (checkFirmaElectronica) {
      let total =
        amount +
        calculateInterest(amount, vencimientoEnDias) +
        calcFirmaElectronica(amount, vencimientoEnDias);
      return total;
    } else {
      let total = amount + calculateInterest(amount, vencimientoEnDias);
      setDctoFirmaElectronica(firmaElectronicaValueRef.current);
      return total;
    }
  }, [checkFirmaElectronica, calculateInterest, calcFirmaElectronica]);

  const handleToggleDialog = () => {
    if (dialogOpen) {
      setDialogOpen(false);
    } else {
      setDialogOpen(true);
    }
  };

  const handleOpenAlert = (message) => {
    setViewalert(!viewalert);
    setIsOpenAlert(!isOpenAlert);
    setMessageAlert(message);
    setTimeout(() => {
      setViewalert(false);
      setIsOpenAlert(false);
      setMessageAlert("");
    }, 5000);
  };

  const handleClearStateAlert = () => {
    setViewalert(false);
    setMessageAlert("");
    setIsOpenAlert(false);
    return;
  };

  const loadCreditById = async (creditId) => {
    try {
      const data = await HttpRequest.getCreditById(creditId);
      return data.message.info;
    } catch (error) {
      console.log(error);
    }
  };

  const getAvailableReward = async () => {
    try {
      let { data } = await apiClient.get(
        GET_AVAILABLE_REWARD + localStorage.getItem("doc")
      );
      let availableReward = data?.data;
      return availableReward;
    } catch (error) {
      console.log(error);
      return {};
    }
  };

  const handleSetAvailableReward = async () => {
    let availableReward = await getAvailableReward();
    setRewardHistoryAvailable(availableReward);
    return;
  };

  const calcDiscountForReward = (availableReward) => {
    if (availableReward && availableReward?.rewardHistoryAvailable) {
      let shortCode = availableReward?.shortCodeReward;
      let typeReward = String(shortCode).substring(1, 3);
      if (typeReward === "10") {
        let percentage =
          availableReward?.rewardHistoryAvailable?.percentDiscount;
        let discountReward = (firmaElectronicaValue * percentage) / 100;
        return discountReward;
      } else {
        return 0;
      }
    } else {
      return 0;
    }
  };

  const handleClickFirmaFisico = () => {
    setOpenModalFirmaFisica(true);
    setCheckFirmaElectronica(false);
    setDisableButton(true);
  };

  const handleClickFirmaElectronica = () => {
    setCheckFirmaElectronica(true);
    setDisableButton(false);
  };

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      if (
        !checkAcceptContract ||
        !checkAcceptPromissory ||
        !checkValidateAccount
      ) {
        handleOpenAlert(
          "Debes aceptar el contrato, el pagaré y confirmar tu cuenta antes de continuar."
        );
        return;
      }
      if (!checkFirmaElectronica) {
        return;
      }
      let creditPayload = preparePayload();
      if (environment !== "PROD") {
        console.log(creditPayload);
      }

      await CreditsService.updateCreditFromOfferPage({
        credit: creditPayload,
        creditId: creditData.credit_id,
        documento: localStorage.getItem("doc"),
      });

      //Aceptar condiciones
      let payloadAceptarCondiciones = {
        doc: localStorage.getItem("doc"),
        phone: userinfo?.phone,
        credit_id: creditData.credit_id,
      };

      const responseService = await HttpRequest.requestSignature(
        payloadAceptarCondiciones
      );
      if (responseService.error) {
        handleOpenAlert(
          "Ocurrió un error al realizar la solicitud, intenta más tarde."
        );
        return;
      }
      return navigate("/firma", {
        state: { doc: creditData.documento, isRenovateCredit: false },
      });
    } catch (error) {
      console.log(error);
      handleOpenAlert("Ha ocurrido un error interno, intenta más tarde..");
      return;
    }
  };

  const handleRequestPhysicalSignature = async () => {
    try {
      if (successRequestPhysicalSignature) {
        handleOpenAlert(
          "Ya enviaste una vez la solicitud de firma física, debes realizar los pasos siguientes."
        );
        return;
      }
      let creditPayload = preparePayload(true);
      setOpenLoader(true);
      try {
        await CreditsService.updateCreditFromOfferPage({
          credit: creditPayload,
          creditId: creditData.credit_id,
          documento: creditData.documento,
        });
      } catch (error) {
        console.log("Error al actualizar el credito");
        console.log(error);
      }

      const response = await apiClient.create(
        REQUEST_PROCESS_PHYSICAL_SIGNATURE,
        {
          documento: creditData.documento,
          creditId: creditData.credit_id,
        }
      );

      if (response.status === 200) {
        setOpenLoader(false);
        setOpenDialog(true);
        setSuccessRequestPhysicalSignature(true);
        setOpenModalFirmaFisica(false);
        return;
      }
      setOpenLoader(false);
    } catch (error) {
      console.log(error);
      handleOpenAlert("Ha ocurrido un error interno, intenta más tarde..");
      setOpenLoader(false);
      return;
    }
  };

  const preparePayload = (isPhysical = false) => {
    let newCreditData = { ...creditData };
    newCreditData.totalToPay = total;
    newCreditData.firmaElectronica = !isPhysical ? firmaElectronicaValue : 0;
    newCreditData.dctoFirmaElectronica = !isPhysical ? dctoFirmaElectronica : 0;
    newCreditData.interestRate = 0;
    newCreditData.tipoFirma = "electronica";
    newCreditData.status = "Pendiente de firmar";
    newCreditData.tasaInteresCorriente = localStorage.getItem(
      "currentInterestRate"
    );
    setCreditData(newCreditData);
    let acceptanceDate = moment().format("DD/MM/YYYY");

    updateCreditUser({
      ...creditUser,
      acceptanceDate: acceptanceDate,
      status: "Pendiente de firmar",
      totalToPay: total,
      interestRate: 0,
    });

    let creditPayload = {
      termInDays:
        newCreditData.termInDays !== creditUser.termInDays
          ? creditUser.termInDays
          : newCreditData.termInDays,
      totalToPay: total,
      paydayLimit:
        newCreditData.paydayLimit !== creditUser.paydayLimit
          ? creditUser.paydayLimit
          : newCreditData.paydayLimit,
      interestRate: newCreditData.interestRate,
      dctoFirmaElectronica: newCreditData.dctoFirmaElectronica,
      acceptanceDate: checkFirmaElectronica ? acceptanceDate : "",
      tipoFirma: newCreditData.tipoFirma,
      firmaElectronica: newCreditData.firmaElectronica,
      tasaInteresCorriente: newCreditData.tasaInteresCorriente,
    };
    return creditPayload;
  };

  const flowFromApi = async () => {
    if (fromapi && (fromapi === true || fromapi === "true")) {
      try {
        console.log(
          "Proviene de API, se procede a generar datos de usuario..."
        );

        let data = await loadCreditById(creditIdFromApi);
        updateCreditUser({
          credit_id: creditIdFromApi,
          approvedQuota: cupoAprobado,
          termInDays: data?.termInDays,
          totalToPay: data?.totalToPay,
          paydayLimit: data?.paydayLimit,
          documento: data?.documento,
          approvedDate: data?.approvedDate,
        });

        //Generar el token al usuario y crea la sesión
        let { message } = await AuthService.generateTokenClient({
          doc: data?.documento,
        });
        setDataToLocalStorage({
          otp: message?.otp,
          creditId: creditIdFromApi,
          documento: data?.documento,
          typeUser: "client",
          isSignin: true,
          idOperation: idOperation,
        });
        return;
      } catch (error) {
        console.error("Ocurrió un error al generar token al usuario.");
        console.error(error);
        handleOpenAlert(
          `Ocurrió un error al generar la autenticación, intente más tarde.`,
          true
        );
        setTimeout(() => {
          handleClearStateAlert();
          return navigate("/");
        }, 5000);
      }
    } else {
      return;
    }
  };

  useEffect(() => {
    const validateSessionNow = async () => {
      const type_user = localStorage.getItem("type_user");

      const validSessionAndTokenJwt = async () => {
        try {
          let isValidToken = await validateSessionAndJwtToken();
          return isValidToken;
        } catch (error) {
          return false;
        }
      };

      if (type_user === "visitor" || type_user === "client") {
        validSessionAndTokenJwt().then(async (isValidToken) => {
          if (isValidToken) {
            setIsLoading(false);
          } else {
            localStorage.clear();
            localStorage.setItem("is_signin", false);
            return navigate("/");
          }
        });
      } else {
        localStorage.clear();
        localStorage.setItem("is_signin", false);
        return navigate("/");
      }
    };
    flowFromApi().then(async () => {
      //Agregar timeline a funnel
      /* handleAddTimeline(
        idOperation ? idOperation : null,
        localStorage.getItem("credit_id")
      )
        .then((message) => console.log("ok"))
        .catch((e) => console.log(e)); */

      validateSessionNow()
        .then(async () => {
          try {
            let hasValidCredit = await handleValidateUserHasValidCredit(
              localStorage.getItem("doc")
            );
            if (hasValidCredit === true) {
              return navigate("/micredito");
            }
            await handleSetAvailableReward();
            let data = await loadCreditById(localStorage.getItem("credit_id"));
            if (data?.status === "Cancelado") {
              handleOpenAlert(
                "Lo sentimos, su solicitud ha sido cancelada. Por favor, intente nuevamente o comuníquese con nosotros."
              );
              return navigate("/");
            }
            updateCreditContextFromViewOffer(data, updateCreditUser);
            setCreditData(data);
            let { isChanges, creditChanges } =
              await validateCreditDatesFromViewOffer(data);
            if (isChanges) {
              updateCreditUser({ ...creditUser, creditChanges });
              setCreditData({ ...creditData, creditChanges });
            }
            let infoUser = await loadInfoUser(localStorage.getItem("doc"));
            let infoUserAuth = await loadInfoUserAuth(
              localStorage.getItem("doc")
            );
            localStorage.setItem("phone", infoUserAuth?.phone);
            setBasicInfo(infoUser);
            setUserinfo(infoUserAuth);
            updateBasicInfo(infoUser);
            updateMyBanksContextFromViewOffer(infoUser, updateMyBanks, myBanks);
          } catch (error) {
            console.log(error);
            return navigate("/");
          }
        })
        .catch((e) => console.log(e))
        .finally(() => {
          setIsLoading(false);
        });
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    (async () => {
      let _tmlvData = localStorage.getItem("tmlv");
      let rate = "25,00";
      if (_tmlvData) {
        let Tmlv = JSON.parse(_tmlvData);
        if (Tmlv) {
          setTasaUsuraTmlvRate(Tmlv[0]?.rate);
          rate = Tmlv[0]?.rate;
        }
      }
      await getInterest();
      let _interest = calculateInterest(
        convertToNumber(creditUser.approvedQuota),
        creditUser.termInDays,
        rate
      );
      setInterest(_interest);
      await getAndSetInterestTea();
    })();
    // `calculateInterest` se omite a propósito: no está memoizada (se redefine en
    // cada render y depende de `tasaUsuraTmlvRate`), y este efecto llama a
    // setInterest(...). Si se agrega tal cual, la nueva identidad de la función en
    // cada render dispara el efecto de nuevo -> setInterest -> nuevo render ->
    // nueva identidad -> loop infinito de recálculo de interés. Requiere memoizar
    // `calculateInterest` (useCallback) con sus dependencias reales antes de poder
    // agregarla aquí con seguridad; no se modifica el cálculo financiero sin
    // validación humana.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [total, creditUser]);

  useEffect(() => {
    let discountForReward = calcDiscountForReward(rewardHistoryAvailable);
    setDiscountForReward(discountForReward);
    const _total = calculateTotal(
      convertToNumber(creditUser.approvedQuota),
      creditUser.termInDays
    );
    if (checkFirmaElectronica) {
      setTotal(_total - discountForReward);
    } else {
      setTotal(_total);
    }
    setFirmaElectronicaValue(variablesGlobales.firmaElectronica);
    updateCreditUser({
      ...creditUser,
      dctoFirmaElectronica: dctoFirmaElectronica,
      firmaElectronica: firmaElectronicaValue,
      interestRate: interest,
      tipoFirma: checkFirmaElectronica ? "electronica" : "fisica",
      totalToPay: total,
    });
    // `calcDiscountForReward`, `calculateTotal`, `creditUser`, `dctoFirmaElectronica`,
    // `firmaElectronicaValue` y `updateCreditUser` se omiten a propósito: este
    // efecto llama a updateCreditUser(...) (dispara un cambio en `creditUser` vía
    // contexto) y a calculateTotal(...), que internamente invoca
    // calcFirmaElectronica(...) y esta última hace setDctoFirmaElectronica(...).
    // Si `creditUser` o `dctoFirmaElectronica` entraran en este arreglo, cada
    // ejecución del efecto volvería a cambiar esos valores, re-disparando el
    // efecto indefinidamente (loop de recálculo de interés/descuento/total). Este
    // es cálculo financiero sensible (interés, descuento por firma electrónica,
    // total a pagar); no se debe romper esta cadena sin validación humana y
    // pruebas end-to-end del flujo de oferta de crédito.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [total, interest, checkFirmaElectronica, rewardHistoryAvailable]);

  useEffect(() => {
    setBasicInfo((prevBasicInfo) => ({
      ...prevBasicInfo,
      bankAccount: myBanks.parentAccount?.bankAccount,
      typeBankAccount: myBanks.parentAccount?.typeBankAccount,
      accountNumber: myBanks.parentAccount?.accountNumber,
    }));
    let bankAccountValue = bankAccountOptionsFiltered.filter(
      (acc) => acc.label === myBanks.parentAccount?.bankAccount
    )[0]?.value;
    apiClient
      .put(`${UPDATE_BASIC_INFO}${localStorage.getItem("doc")}`, {
        update: {
          bankAccount: bankAccountValue,
          typeBankAccount: myBanks.parentAccount?.typeBankAccount,
          accountNumber: myBanks.parentAccount?.accountNumber,
        },
      })
      .then((response) => console.log(response.statusText))
      .catch((error) => console.log(error));
  }, [myBanks.parentAccount]);

  if (isLoading) {
    return (
      <Fragment>
        <ViewTimer
          creditId={localStorage.getItem("credit_id")}
          viewName="Oferta"
          description="Oferta de crédito"
          pathView="/oferta"
          hasSuccess={true}
          onSaveTimeline={handleAddTimeline}
        />

        <div className="bg-red/10">
          <Steps
            estado1="complete"
            estado2="complete"
            estado3="current"
            estado4="upcoming"
          />
          <Forms
            title={
              <div>
                <span>Cargando ...</span>
              </div>
            }
            description={
              <div>
                <span></span>
              </div>
            }
            form={
              <form action="#" method="POST">
                <div className="shadow-lg overflow-hidden rounded-md">
                  <div className="px-4 py-5 bg-white sm:p-6"></div>
                </div>
              </form>
            }
          />
        </div>
      </Fragment>
    );
  }

  return (
    <div className="bg-purpleLight mb-10 h-screen">
      {/* <TagManager /> */}
      <img
        src="https://leadgenios.net/pixel.track?CID=450913&p=img&MerchantReferenceID="
        width="1"
        height="1"
        border="0"
        alt=""
      />
      <Steps
        estado1="complete"
        estado2="complete"
        estado3="current"
        estado4="upcoming"
      />
      {viewalert && (
        <>
          <ErrorAlert isOpen={isOpenAlert} message={messsageAlert}></ErrorAlert>
        </>
      )}
      {openDialog && (
        <PhysicalSignatureSuccessDialog
          dialogOpen={openDialog}
          setDialogOpen={setOpenDialog}
        />
      )}
      <Forms
        title={
          <div>
            <span>
              ¡Felicidades, te hemos aprobado un cupo de{"  "}
              <Numeral
                format={"$0,0"}
                value={creditUser?.approvedQuota || cupoAprobado}
              />
              !
            </span>
          </div>
        }
        description={<span></span>}
        form={
          <form action="#" method="POST">
            <div className="shadow-lg overflow-hidden rounded-3xl">
              <div className="px-4 py-5 bg-white sm:p-6 sm:px-8">
                <div className="text-center pb-10 text-xl lg:text-2xl font-bold">
                  Confirma las condiciones de tu crédito
                </div>
                <div className="lg:flex justify-between gap-4 w-full">
                  <div className="w-full lg:flex justify-between">
                    <div className="w-full pb-4 text-left">
                      <div>
                        <span className="">Cupo aprobado</span>
                      </div>
                      <Numeral
                        className="text-2xl font-bold"
                        format={"$0,0"}
                        value={creditUser.approvedQuota || cupoAprobado}
                      />
                    </div>
                    <div className="w-full pb-4 text-left">
                      <div>
                        <span className="">Plazo acordado</span>
                      </div>
                      <span className="text-2xl font-bold">
                        {creditUser.termInDays} días
                      </span>
                    </div>
                  </div>
                  <div className="w-full lg:flex justify-between">
                    <div className="w-full text-left">
                      <div className="pb-4">
                        <span className="block">Total a pagar</span>

                        <div className="flex justify-start">
                          <Numeral
                            className="text-2xl font-bold"
                            format={"$0,0"}
                            value={total}
                          />
                          <TooltipInfoV2
                            showTooltip={tooltip}
                            approvedQuota={creditUser.approvedQuota}
                            interest={interest}
                            dctoFirmaElectronica={
                              checkFirmaElectronica ? dctoFirmaElectronica : 0
                            }
                            firmaElectronica={
                              checkFirmaElectronica ? firmaElectronicaValue : 0
                            }
                            discountForReward={discountForReward}
                            checkFirmaElectronica={checkFirmaElectronica}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="w-full text-left">
                      <div className="pb-8 lg:pb-16">
                        <span className="block">Fecha límite de pago</span>
                        <span className="text-2xl font-bold">
                          {creditUser.paydayLimit}
                        </span>
                        <div className="block">
                          <button
                            type="button"
                            onClick={handleToggleDialog}
                            className="text-purple text-sm"
                          >
                            Ver fechas disponibles
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="w-full lg:flex justify-between">
                  <div className="w-full">
                    <div className="flex items-center lg:pt-4">
                      <input
                        id="contract"
                        name="contract"
                        required
                        type="checkbox"
                        className="h-4 w-4 text-purple focus:ring-0 border-gray-300 rounded-sm cursor-pointer"
                        value={checkAcceptContract}
                        onChange={(e) =>
                          setCheckAcceptContract(e.target.checked)
                        }
                      />
                      <label className="text-sm lg:text-base ml-2 flex gap-2">
                        Acepto el contrato de mutuo{" "}
                        <ViewContract
                          basicInfo={basicInfo}
                          userinfo={userinfo}
                          creditUser={creditUser}
                          firmaElectronica={
                            checkFirmaElectronica ? firmaElectronicaValue : 0
                          }
                          dctoFirmaElectronica={
                            checkFirmaElectronica ? dctoFirmaElectronica : 0
                          }
                          total={total}
                        />
                      </label>
                    </div>
                    <div className="flex items-center pt-1">
                      <input
                        id="promissory"
                        name="promissory"
                        required
                        type="checkbox"
                        className="h-4 w-4 text-purple focus:ring-0 border-gray-300 rounded-sm cursor-pointer"
                        value={checkAcceptPromissory}
                        onChange={(e) =>
                          setCheckAcceptPromissory(e.target.checked)
                        }
                      />
                      <label className=" flex gap-2 text-sm lg:text-base ml-2">
                        <div>
                          Acepto pagaré y carta de instrucciones
                        </div>
                        <ViewPromissory
                          basicInfo={basicInfo}
                          userinfo={userinfo}
                        />
                      </label>
                    </div>
                    <div className="flex items-center pt-1">
                      <input
                        id="banckAccount"
                        name="banckAccount"
                        required
                        type="checkbox"
                        className="h-4 w-4 text-purple focus:ring-0 border-gray-300 rounded-sm cursor-pointer"
                        value={checkValidateAccount}
                        onChange={(e) =>
                          setCheckValidateAccount(e.target.checked)
                        }
                      />
                      <label className=" flex gap-2 text-sm lg:text-base ml-2">
                        <div>Mi cuenta bancaria es correcta</div>
                        <ViewBankAccount />
                      </label>
                    </div>
                  </div>
                  <div className="w-full pt-8 lg:pt-0">
                    <div className="font-bold">Elige como quieres firmar</div>

                    <div className="flex gap-2 pt-2">
                      <div
                        onClick={handleClickFirmaElectronica}
                        className={`w-full bg-white rounded-3xl p-4 mb-4 cursor-pointer ${
                          checkFirmaElectronica
                            ? "border-2 border-purple"
                            : "border-purpleLight"
                        }`}
                      >
                        <div className="flex justify-between">
                          <div>Firma Electrónica</div>
                          {checkFirmaElectronica && (
                            <div className="grid content-center justify-items-center w-5 h-5 rounded-full bg-green">
                              <CheckIcon className=" w-4 h-auto text-white" />
                            </div>
                          )}
                        </div>
                      </div>

                      <div
                        className={"w-full"}
                        onClick={handleClickFirmaFisico}
                        href="#"
                      >
                        <div className="cursor-pointer min-w-full">
                          <div
                            className={`w-full bg-white rounded-3xl p-4 mb-4 cursor-pointer ${
                              !checkFirmaElectronica
                                ? "border-2 border-purple"
                                : "border-purpleLight"
                            }`}
                          >
                            <div className="flex justify-between">
                              <div>Firma en físico</div>
                              {!checkFirmaElectronica && (
                                <div className="grid content-center justify-items-center w-5 h-5 rounded-full bg-green">
                                  <CheckIcon className=" w-4 h-auto text-white" />
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>

                      <ManualSign
                        isOpen={openModalFirmaFisica}
                        setOpen={setOpenModalFirmaFisica}
                        openLoader={openLoader}
                        setOpenLoader={setOpenLoader}
                        handleRequestPhysicalSignature={
                          handleRequestPhysicalSignature
                        }
                      />
                    </div>
                  </div>
                </div>

                <div className="flex py-6 md:flex md:justify-end bg-white text-right sm:px-6">
                  <div className="md:w-56 w-full">
                    <button
                      onClick={handleSubmit}
                      disabled={disableButton}
                      type="button"
                      className={`${
                        !checkFirmaElectronica
                          ? "bg-tgray"
                          : "bg-purple transition duration-300 hover:bg-purpleDark focus:outline-hidden hover:scale-110 hover:cursor-pointer"
                      } w-full flex justify-center py-2 px-4 border border-transparent rounded-full shadow-xs text-lg text-white font-semibold`}
                    >
                      <div className="flex">Continuar</div>
                    </button>
                  </div>
                </div>

                {dialogOpen ? (
                  <OfferDialog
                    dialogOpen={dialogOpen}
                    setDialogOpen={setDialogOpen}
                    creditUser={creditUser}
                    updateCreditUser={updateCreditUser}
                  />
                ) : (
                  <></>
                )}
              </div>
            </div>
          </form>
        }
      />
      <FloatFooter />
    </div>
  );
}
